import React, { useState } from 'react';
import CaseStudyPopup from '../../../Common/Popups/CaseStudiesPopup';
import RatingStar from '../../../Common/RatingStar';
import {
  increaseViewCount,
  composeArrayForRatings,
  randomIntFromInterval,
  getCookie,
} from '../../../Common/CommonMethods';
import LeadGen from '../../../Common/Popups/LeadGen';
import ImageLoader from '../../../Common/ImageLoader';
import { openAPI } from '../../../../config';

const FeatureBoxCSUnit = (props) => {
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [vendorCaseStudy, setVendorCaseStudy] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props,
  });

  const handleExitUrl = (exit_url) => {
    openAPI
      .put(
        `${process.env.REACT_APP_API_URL}${exit_url.replace('/api/v1', '')}`,
        {},
        {
          withCredentials: true,
          headers: {
            'X-CSRFToken': `${getCookie('fc_react_csrfmiddlewaretoken')}`,
          },
        }
      )
      .then((response) => {
        if (!!response.data.exit_url) {
          openInNewTab(response.data.exit_url);
        }
      })
      .catch((error) => {});
  };

  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorCaseStudy,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorCaseStudy(tempObj);
  };

  const openInNewTab = (href) => {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href,
    }).click();
  };

  const postLeadRegPopUp = (url) => {
    setVendorCaseStudy({
      ...vendorCaseStudy,
      activeVideoPopUp: {
        isPopUpActive: true,
      },
      toLocation: props.pathname,
    });
    handleExitUrl(vendorCaseStudy.exit_url);
    //openInNewTab(vendorCaseStudy.exit_url);
  };
  return (
    <li>
      <img src={`/images/case_study_bg_pattern${props.index}.webp`} alt="" />
      <RatingStar
        starCount={composeArrayForRatings(
          vendorCaseStudy.rating.aggregate_score
        )}
      />

      <div className="txt">
        <div className="logo">
          <img
            src={vendorCaseStudy.customer_logo}
            alt=""
            title={vendorCaseStudy.customer_name}
          />
        </div>
        {vendorCaseStudy.title}
      </div>
      {Boolean(Object.keys(vendorCaseStudy.contactdetail).length) ? (
        <div className="profile">
          <ImageLoader
            image={vendorCaseStudy.contactdetail.photo}
            fallbackImage={'/images/avatar.webp'}
          />

          <div className="details">
            {vendorCaseStudy.contactdetail.name ? (
              <span className="name">{vendorCaseStudy.contactdetail.name}</span>
            ) : null}
            {vendorCaseStudy.contactdetail.jobtitle ? (
              <span className="desn" style={{ textTransform: 'uppercase' }}>
                {vendorCaseStudy.contactdetail.jobtitle}
              </span>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="btn btn-primary">
        <a
          href="javascript:void(0)"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            if (props.isLeadGenPopUp) {
              setLeadGenPopUp(true);
            } else {
              handleExitUrl(vendorCaseStudy.exit_url);
              // increaseViewCount(
              //   process.env.REACT_APP_API_URL,
              //   'cs',
              //   vendorCaseStudy.id
              // );
              setVendorCaseStudy({
                ...vendorCaseStudy,
                activeVideoPopUp: {
                  isPopUpActive: true,
                },
                toLocation: props.pathname,
              });
              //openInNewTab(vendorCaseStudy.exit_url);
            }
          }}
        >
          Read In Full
        </a>
      </div>
      {vendorCaseStudy.activeVideoPopUp &&
      vendorCaseStudy.activeVideoPopUp.isPopUpActive ? (
        <CaseStudyPopup
          caseStudyDataForPopUp={vendorCaseStudy}
          isDataFromProps={true}
          setPopUpFalse={setPopUpFalse}
        />
      ) : null}
      {isLeadGenPopUp ? (
        <LeadGen
          {...props}
          setLeadGenPopUp={setLeadGenPopUp}
          postLeadRegPopUp={postLeadRegPopUp}
          pathname={props.pathname.replace('/case-studies', '')}
          linkedInUrl={props.linkedInUrl}
        />
      ) : null}
    </li>
  );
};

export default FeatureBoxCSUnit;
